/**
 * IDs analytics du site public.
 * Laisse CLARITY_PROJECT_ID vide pour desactiver Microsoft Clarity.
 */
export const GA_MEASUREMENT_ID = "G-YV0Z1WC5LG";
export const CLARITY_PROJECT_ID = "xsh5lz6i38";

/**
 * Balise de verification Google Search Console.
 * Collez ici UNIQUEMENT le contenu de l'attribut `content` de la balise
 * <meta name="google-site-verification" content="..."> fournie par Google.
 * Laissez vide pour ne pas emettre la balise.
 */
export const GSC_VERIFICATION = "";
